import request from "../plugins/axios";

export function filterContact(params) {
    return request({
        url: '/workContact/filterContact',
        method: 'GET',
        params
    })
}
